// ----------------------------------------------------------------------------
// Section: Fabrics Page Hero
// ----------------------------------------------------------------------------
//
// Hero section for fabric pages - minimal JavaScript needed
//
// ----------------------------------------------------------------------------

// -------------------------------------
// Dependencies
// -------------------------------------

// Styles
import './_fabrics-page-hero.scss';

// -------------------------------------
// Variables
// -------------------------------------

const SECTION_SELECTOR = '[data-section-id]';

// -------------------------------------
// Helpers
// -------------------------------------

const initFabricsPageHero = (section) => {
    // Handle anchor linking if needed
    const handleAnchorLink = () => {
        const hash = window.location.hash.substring(1);
        if (!hash) return;

        const sectionAnchor = section.id;
        if (hash === sectionAnchor) {
            section.scrollIntoView({ behavior: 'smooth' });
        }
    };

    // Handle anchor links on page load
    if (window.location.hash) {
        handleAnchorLink();
    }

    // Handle anchor links on hash change
    window.addEventListener('hashchange', handleAnchorLink);
};

// -------------------------------------
// Events
// -------------------------------------

document.addEventListener('DOMContentLoaded', () => {
    const sections = document.querySelectorAll(SECTION_SELECTOR);

    sections.forEach(section => {
        if (section.classList.contains('page-section--fabrics-page-hero')) {
            initFabricsPageHero(section);
        }
    });
});

// Handle Shopify section events
document.addEventListener('shopify:section:load', (event) => {
    const section = event.target;
    if (section.classList.contains('page-section--fabrics-page-hero')) {
        initFabricsPageHero(section);
    }
});

document.addEventListener('shopify:section:unload', (event) => {
    const section = event.target;
    if (section.classList.contains('page-section--fabrics-page-hero')) {
        // Cleanup if needed
    }
});
